import axios from '../axios';
import config from "../../../config";

export default {
    sendEmail({body, subject, to, file }) {

        let data = new FormData();
        data.append('Body', body );
        data.append('Subject', subject);
        if(file)data.append('Attachment',file)
        if(to)data.append('EmailTo', to)
        axios.post(config.host + '/misc/SendEmail', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
    }
}
